// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f0cb673c","885":"37ab4030"}[chunkId] + ".chunk.js";
};